// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"197":"b624fa09","641":"d625676a","821":"db42c959"}[chunkId] + ".chunk.css";
};